export default __webpack_public_path__ + "static/jerrel1-38cf53d431679ca52d6339e1bfb673c9.jpg";